import { Injectable, inject } from '@angular/core';
import { BoelsCatalogVersion, BoelsCategoryHierarchy } from '@boels/models';
import { concatLatestFrom } from '@ngrx/operators';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CultureFacade } from '../../cultures/facade/cultures.facade';
import {
  getCatalogsForActiveBaseSiteAndCulture,
  loadCatalogs,
} from '../actions/catalogs.action';
import { CatalogsState } from '../reducers/catalogs.reducer';
import {
  selectCatalogsEntities,
  selectCatalogsError,
  selectCatalogsLoading,
  selectCatalogsSuccess,
  selectCategoryForId,
  selectParentCategoryforId,
} from '../selectors/catalog.selector';

@Injectable({
  providedIn: 'root',
})
export class CatalogsFacade {
  protected store = inject<Store<CatalogsState>>(Store);
  protected cultureFacade = inject(CultureFacade);

  loading$: Observable<boolean> = this.store.select(selectCatalogsLoading);
  success$: Observable<boolean> = this.store.select(selectCatalogsSuccess);
  error$: Observable<boolean> = this.store.select(selectCatalogsError);

  getCatalogs(): Observable<BoelsCatalogVersion | undefined> {
    this.store.dispatch(getCatalogsForActiveBaseSiteAndCulture());
    return this.store.pipe(
      select(selectCatalogsEntities),
      concatLatestFrom(() => this.cultureFacade.getActiveCulture()),
      map(([catalogMap, activeCulture]) => {
        if (activeCulture) {
          return catalogMap[activeCulture];
        }
        return undefined;
      }),
    );
  }

  loadCatalogs(baseSite: string, culture: string) {
    this.store.dispatch(loadCatalogs({ baseSite, culture }));
  }

  getParentCategoryforId(
    baseSite: string,
    culture: string,
    categoryId: string,
  ) {
    return this.store.pipe(
      select(selectParentCategoryforId({ culture, categoryId })),
      filter(Boolean),
    );
  }

  getCategoryForId(
    baseSite: string,
    culture: string,
    categoryId: string,
  ): Observable<BoelsCategoryHierarchy | undefined> {
    return this.store.pipe(
      select(selectCategoryForId({ culture, categoryId })),
    );
  }
}
